import { render } from "./MainBlock.vue?vue&type=template&id=4b0b7afe"
import script from "./MainBlock.vue?vue&type=script&lang=js"
export * from "./MainBlock.vue?vue&type=script&lang=js"

import "./MainBlock.vue?vue&type=style&index=0&id=4b0b7afe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__